import { ComponentType } from 'react'
import { StackNavigationOptions } from '@react-navigation/stack'
import { RouteProp } from '@react-navigation/native'

import GenericResourceScreen from '../screens/resource/GenericResourceScreen'
import GenericLocationsScreen from '../screens/locations'
import {SuspicionCheckerAcuteDangerChildrenScreen, SuspicionCheckerLatentDangerChildrenScreen, SuspicionCheckerNeedForAdviceChildrenScreen} from '../screens/suspicion-checker'

type ScreenConfig = {name: string, component: ComponentType<any>, options?: StackNavigationOptions | ((props: { route: RouteProp<Record<string, any | undefined>, string>; navigation: any; }) => StackNavigationOptions) | undefined}

const commonStackNavigatorScreens: Array<ScreenConfig> =[
  // Generic screens
  {
    name: 'GenericResource',
    component: GenericResourceScreen,
    options: ({ route }) => ({ title: route.params.name || '' })
  },
  {
    name: 'GenericLocations',
    component: GenericLocationsScreen,
    options: ({ route }) => ({ title: route.params.name || '' })
  },
  // Suspicion Checker
  {
    name: 'SuspicionCheckerAcuteDangerChildren',
    component: SuspicionCheckerAcuteDangerChildrenScreen,
    options: {
      title: 'Akute Kindeswohlgefährdung',
    }
  },
  {
    name: 'SuspicionCheckerLatentDangerChildren',
    component: SuspicionCheckerLatentDangerChildrenScreen,
    options: {
      title: 'Latente Kindeswohlgefährdung',
    }
  },
  {
    name: 'SuspicionCheckerNeedForAdviceChildren',
    component: SuspicionCheckerNeedForAdviceChildrenScreen,
    options: {
      title: 'Beratungsbedarf Eltern',
    }
  },
]



export default commonStackNavigatorScreens